import { EditInfo, FullScreenLoadingSpinner, MainTitle } from 'ck-components';

import { PollsCreateForm } from 'ck-features';
import { TypedNavigate } from 'ck-utils';
import { useParams } from 'react-router-dom';
import { usePollsPrefill } from 'ck-queries';

interface Props {
  isEdit?: boolean;
  isCopy?: boolean;
}

export function PollsCreatePage({ isEdit, isCopy }: Props) {
  const { id } = useParams();
  const { data, isLoading, isError } = usePollsPrefill(id, Boolean(isCopy));
  const prefill = data?.prefill;

  if (isLoading) {
    return <FullScreenLoadingSpinner />;
  }

  if (isError) {
    return (
      <p>
        Något gick fel vid inläsning av sidan. Prova uppdatera din webbläsare.
      </p>
    );
  }

  if (!prefill && id) {
    return <TypedNavigate to='/polls/create' replace={true} />;
  }

  const mainTitle = isEdit
    ? 'Redigera omröstning'
    : isCopy && prefill?.titleSwedish
    ? prefill.titleSwedish
    : 'Skapa omröstning';

  return (
    <div className='flex flex-1 flex-col'>
      {prefill && <EditInfo isDraft={isEdit && prefill.isDraft} />}
      <MainTitle label={mainTitle} customStyle='pb-8' />

      <PollsCreateForm isCopy={isCopy} isEdit={isEdit} prefill={prefill} />
    </div>
  );
}
